import React, { useState } from 'react';
import {
  ContactInformationIdentifierType,
  IdentifierType,
} from 'routes/profile/models/Identifier';
import ReceiptLookupOtpRequest from './ReceiptLookupOtpRequest';
import ReceiptLookupOtpVerify from './ReceiptLookupOtpVerify';

enum OtpStep {
  Request = 0,
  Verify = 1,
}

type Props = {
  onVerified: () => void;
};

/**
 * Orchestrates the two OTP sub-steps (request code → verify code) that gate the account-less receipt
 * lookup. Calls `onVerified` once the backend has confirmed the code and set the proof cookie.
 */
const ReceiptLookupOtp: React.FC<Props> = ({ onVerified }) => {
  const [step, setStep] = useState<OtpStep>(OtpStep.Request);
  const [identifierType, setIdentifierType] =
    useState<ContactInformationIdentifierType>(IdentifierType.Email);
  const [identifierValue, setIdentifierValue] = useState<string>('');

  if (step === OtpStep.Verify) {
    return (
      <ReceiptLookupOtpVerify
        identifierType={identifierType}
        identifierValue={identifierValue}
        onClickBack={() => setStep(OtpStep.Request)}
        onVerified={onVerified}
      />
    );
  }

  return (
    <ReceiptLookupOtpRequest
      onCodeSent={(type, value) => {
        setIdentifierType(type);
        setIdentifierValue(value);
        setStep(OtpStep.Verify);
      }}
    />
  );
};

export default ReceiptLookupOtp;
